import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { FaSearch } from "react-icons/fa";
import CategoryAside from "./CategoryAside";
import { addToCart } from "../redux/features/cartSlice";
import Loader from "./Loader";
import { fetchProducts } from "../services/productService";
import ProductCard from "./product/ProductCard";
import Pagination from "./Pagination";

const ProductList = () => {
  const [inputFilter, setinputFilter] = useState("");
  const [categoryFilter, setcategoryFilter] = useState("");
  const inputSearch = useRef("");
  const dispatch = useDispatch();
  const { products, pagination, loader } = useSelector(
    (state) => state.product
  );
  const { current_page, limit, total_items, total_pages } = pagination;

  useEffect(() => {
    dispatch(fetchProducts({ page: current_page, limit }));
  }, [dispatch, current_page]);

  const productsTmp = products?.filter((product) => {
    return product.name.includes(inputFilter);
  });

  const handleInputSearch = (e) => {
    e.preventDefault();
    const inputSearchValue = inputSearch.current.value;
    if (inputSearchValue == "") {
      inputSearch.current.focus();
    }
    setinputFilter(inputSearchValue);
  };
  const filterCategorie = (id) => {
    setcategoryFilter(id);
  };
  const handleAddCart = (product) => {
    dispatch(addToCart(product));
  };
  const handlePaginate = (new_page) => {
    dispatch(fetchProducts({ page: new_page, limit }));
  };
  if (loader) return <Loader />;

  return (
    <>
      <div className="flex justify-end items-center h-full">
        <div className="SearchBar">
          <form action="">
            <div className="relative w-80">
              <input
                type="search"
                id="search-dropdown"
                className="block w-80 p-2.5 z-20 text-sm text-gray-900 bg-gray-50  border border-s-2 border border-gray-300 focus:border-gray-300 focus:outline-none dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                placeholder="Search product..."
                ref={inputSearch}
              />
              <button
                onClick={handleInputSearch}
                type="submit"
                className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-primaryColor border border-primaryColor  focus:ring-0 focus:outline-none focus:ring-blue-300"
              >
                <FaSearch />
                <span className="sr-only">Search</span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="w-fit mx-auto grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 justify-items-center justify-center gap-y-20 gap-x-14 mt-10 mb-5">
        <CategoryAside filterCategorie={filterCategorie}   />
        {productsTmp.map((product) => (
          <ProductCard product={product} key={product.id} />
        ))}
      </div>
      <Pagination
        current_page={current_page}
        total_pages={total_pages}
        handlePaginate={handlePaginate}
      />
    </>
  );
};

export default ProductList;
